import axios from 'axios'
import Qs from 'qs'
import _ from 'lodash'
import router from '../router/index'

const formatParams = (params) => {
  // 过滤空值
  Object.keys(params).map(key => {
    if (params[key] === '' || params[key] === null) {
      delete params[key]
    }
  })

  return params
}

const getQuery = (key) => {
  const keyValue = _.get(router, ['history', 'current', 'query', key])
  return keyValue
}

const getBaseUrl = () => {
  const mp = getQuery('mp')
  const api_base = process.env.VUE_APP_BASE_API
  const api_base_tf = process.env.VUE_APP_BASE_API_TAOFENG
  const api_base_jd_new = process.env.VUE_APP_BASE_API_JINDUO_NEW
  console.log('api, api_tf', api_base, api_base_tf, api_base_jd_new)
  // const api_base = 'https://jinduo.com'
  // const api_base_tf = 'https://market.jinduo.com'
  let baseURL = api_base
  if (mp === 'taofeng') {
    baseURL = api_base_tf
  } else if (mp === 'jinduo_new') {
    baseURL = api_base_jd_new
  }
  return baseURL
}

// create an axios instance
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
  paramsSerializer: function(params) {
    return Qs.stringify(formatParams(params), { arrayFormat: 'brackets' })
  }
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (config.data) {
      config.data = formatParams(config.data)
    }
    // url = base url + request url
    config.baseURL = getBaseUrl()
    // do something before request is sent
    // config.withCredentials = true
    config.headers['token'] = getQuery('token')
    config.headers['program'] = getQuery('program')
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // code 不是0 则是错误
    if (response.status !== 200) {
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service
